module.exports = __webpack_public_path__ + "img/effects_digital_art.49b7010c.jpg";